import NewApiService from "@/utils/new.api.service";

export default {
    loadAccounts(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("bexio/load-accounts")
            .then(({ data }) => {
                context.commit('setAccounts', data.accounts)
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },

    loadTaxes(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("bexio/load-taxes")
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },

    loadCurrencies(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("bexio/load-currencies")
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },
    importUsers(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.put("bexio/import-users")
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },
    createContactGroups(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.put("bexio/contact-groups")
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },
    importClients(context){
        context.commit("loading", true);
        return new Promise((resolve, reject) => {
            NewApiService.put("bexio/import-clients")
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response)
            })
            .finally(() => {
                context.commit("loading", false);
            })
        });
    },
}
